import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const loaderStyles = `
  .pgl-overlay {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    background-color: rgba(240, 241, 243, 0.7);
    z-index: 50;
  }

  .pgl-container {
    --pgl-size: 150px;
    --pgl-speed: 2.5s;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: calc(var(--pgl-size) / 6);
    width: var(--pgl-size);
  }

  .pgl-slice {
    position: relative;
    width: calc(var(--pgl-size) / 6);
    height: 100%;
  }

  .pgl-slice::before,
  .pgl-slice::after {
    content: "";
    position: absolute;
    left: 0;
    top: calc(50% - var(--pgl-size) / 12);
    width: calc(var(--pgl-size) / 6);
    height: calc(var(--pgl-size) / 6);
    border-radius: 50%;
    flex-shrink: 0;
    animation: pgl-orbit var(--pgl-speed) linear infinite;
    transition: background-color 0.3s ease;
  }

  .pgl-slice:nth-child(1)::after  { animation-delay: calc(var(--pgl-speed) / -2); }
  .pgl-slice:nth-child(2)::before { animation-delay: calc(var(--pgl-speed) / -6); }
  .pgl-slice:nth-child(2)::after  { animation-delay: calc(calc(var(--pgl-speed) / -2) + calc(var(--pgl-speed) / -6)); }
  .pgl-slice:nth-child(3)::before { animation-delay: calc(var(--pgl-speed) / -6 * 2); }
  .pgl-slice:nth-child(3)::after  { animation-delay: calc(calc(var(--pgl-speed) / -2) + calc(var(--pgl-speed) / -6 * 2)); }
  .pgl-slice:nth-child(4)::before { animation-delay: calc(var(--pgl-speed) / -6 * 3); }
  .pgl-slice:nth-child(4)::after  { animation-delay: calc(calc(var(--pgl-speed) / -2) + calc(var(--pgl-speed) / -6 * 3)); }
  .pgl-slice:nth-child(5)::before { animation-delay: calc(var(--pgl-speed) / -6 * 4); }
  .pgl-slice:nth-child(5)::after  { animation-delay: calc(calc(var(--pgl-speed) / -2) + calc(var(--pgl-speed) / -6 * 4)); }
  .pgl-slice:nth-child(6)::before { animation-delay: calc(var(--pgl-speed) / -6 * 5); }
  .pgl-slice:nth-child(6)::after  { animation-delay: calc(calc(var(--pgl-speed) / -2) + calc(var(--pgl-speed) / -6 * 5)); }

  @keyframes pgl-orbit {
    0%   { transform: translateY(calc(var(--pgl-size) * 0.25))   scale(0.73684);  opacity: 0.65; }
    5%   { transform: translateY(calc(var(--pgl-size) * 0.235))  scale(0.684208); opacity: 0.58; }
    10%  { transform: translateY(calc(var(--pgl-size) * 0.182))  scale(0.631576); opacity: 0.51; }
    15%  { transform: translateY(calc(var(--pgl-size) * 0.129))  scale(0.578944); opacity: 0.44; }
    20%  { transform: translateY(calc(var(--pgl-size) * 0.076))  scale(0.526312); opacity: 0.37; }
    25%  { transform: translateY(0%)                             scale(0.47368);  opacity: 0.3;  }
    30%  { transform: translateY(calc(var(--pgl-size) * -0.076)) scale(0.526312); opacity: 0.37; }
    35%  { transform: translateY(calc(var(--pgl-size) * -0.129)) scale(0.578944); opacity: 0.44; }
    40%  { transform: translateY(calc(var(--pgl-size) * -0.182)) scale(0.631576); opacity: 0.51; }
    45%  { transform: translateY(calc(var(--pgl-size) * -0.235)) scale(0.684208); opacity: 0.58; }
    50%  { transform: translateY(calc(var(--pgl-size) * -0.25))  scale(0.73684);  opacity: 0.65; }
    55%  { transform: translateY(calc(var(--pgl-size) * -0.235)) scale(0.789472); opacity: 0.72; }
    60%  { transform: translateY(calc(var(--pgl-size) * -0.182)) scale(0.842104); opacity: 0.79; }
    65%  { transform: translateY(calc(var(--pgl-size) * -0.129)) scale(0.894736); opacity: 0.86; }
    70%  { transform: translateY(calc(var(--pgl-size) * -0.076)) scale(0.947368); opacity: 0.93; }
    75%  { transform: translateY(0%)                             scale(1);        opacity: 1;    }
    80%  { transform: translateY(calc(var(--pgl-size) * 0.076))  scale(0.947368); opacity: 0.93; }
    85%  { transform: translateY(calc(var(--pgl-size) * 0.129))  scale(0.894736); opacity: 0.86; }
    90%  { transform: translateY(calc(var(--pgl-size) * 0.182))  scale(0.842104); opacity: 0.79; }
    95%  { transform: translateY(calc(var(--pgl-size) * 0.235))  scale(0.789472); opacity: 0.72; }
    100% { transform: translateY(calc(var(--pgl-size) * 0.25))   scale(0.73684);  opacity: 0.65; }
  }

  .pgl-slice:nth-child(1)::before, .pgl-slice:nth-child(1)::after { background-color: #334dff; }
  .pgl-slice:nth-child(2)::before, .pgl-slice:nth-child(2)::after { background-color: #333eff; }
  .pgl-slice:nth-child(3)::before, .pgl-slice:nth-child(3)::after { background-color: #3334ff; }
  .pgl-slice:nth-child(4)::before, .pgl-slice:nth-child(4)::after { background-color: #4433ff; }
  .pgl-slice:nth-child(5)::before, .pgl-slice:nth-child(5)::after { background-color: #6633ff; }
  .pgl-slice:nth-child(6)::before, .pgl-slice:nth-child(6)::after { background-color: #9933ff; }
`;


/**
 * FullPageLoader
 *
 * Portals a blurred overlay into <main> (grid-area: main).
 * <main> must have position: relative for the absolute overlay to fill it.
 * Always stays visible for at least 2 seconds once shown.
 *
 * Usage:
 *   const mainRef = useRef(null);
 *
 *   <main ref={mainRef} style={{ position: "relative" }}>
 *     <FullPageLoader loading={isLoading} mainRef={mainRef} />
 *     ...content...
 *   </main>
 */
export function FullPageLoader({ loading }) {
  const [mounted, setMounted] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!document.getElementById("pgl-styles")) {
      const tag = document.createElement("style");
      tag.id = "pgl-styles";
      tag.textContent = loaderStyles;
      document.head.appendChild(tag);
    }
    setMounted(true);
  }, []);

  useEffect(() => {
    setVisible(loading);
  }, [loading]);

  if (!visible || !mounted) return null;

  return createPortal(
    <div className="pgl-overlay" role="status" aria-label="Loading">
      <div className="pgl-container">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="pgl-slice" />
        ))}
      </div>
    </div>,
    document.body,
  );
}
